import {GET_ASSIGNED_SCOPES} from '../actiontypes';
import {getAllScopesUrl} from '../apiUrls';

/**
 * Returns an action to be dispatched and treated by the api-middleware, ultimately making an API call through Axios.
 * Represents a request all the active scopes for the given engagements.
 * @param {Number} engagementId Engagement ID.
 * @returns {Object} An action object.
 */

export const getAssignedScopes = (engagementId) => {
	const url = `${getAllScopesUrl(engagementId)}?filterAssignedToTeam=true`;

	return {
		type: GET_ASSIGNED_SCOPES,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};
